<template>
  <div>
    <v-btn :color="ui.bkgdColor" icon @click="openDialog()">
      <v-icon :color="ui.btnColor">
        info_outline
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row class="mr-3">
            <v-icon large left :color="ui.btnColor"> info_outline </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                {{defineDocumentFromTag(this.data.tag).title}} Help
              </div>
            </span>
            <v-spacer/>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                {{this.data.tag}}
              </div>
            </span>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              {{defineDocumentFromTag(this.data.tag).help1}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-4">
            <div :class="ui.textSubheading">
              {{defineDocumentFromTag(this.data.tag).help2}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-4">
            <div :class="ui.textSubheading">
              {{defineDocumentFromTag(this.data.tag).help3}}
            </div>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import describeDocument from "@/data/describe/mixins/describeDocument.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";

export default {
  mixins: [apptheme, describeDocument],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: true,
      indeterminateProgressBar: false,
      step: 0,
      info: [
        {
          step: 0,
          title: "Action Request",
          icon: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getUser", "getDetail"]),
    stepInfo() {
      return this.info[this.step];
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    }
  }
};
</script>
